var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-section" },
    [
      _c(
        "div",
        {
          staticClass:
            "emd-container _highlight_header _header_spaced _footer_spaced_sm",
        },
        [
          _c("div", { staticClass: "emd-container__header" }, [
            _c("h2", { staticClass: "emd-text _size_section" }, [
              _vm._v(_vm._s(_vm.$t("trf.title"))),
            ]),
            _vm.permissionIsEnabled("trf.report:create")
              ? _c(
                  "button",
                  {
                    staticClass:
                      "emd-btn _color_primary _size_small jsModalOpen",
                    attrs: { id: "btn-open-modal-trf" },
                    on: {
                      click: function ($event) {
                        return _vm.openModal("custom")
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "uil uil-plus" }),
                    _vm._v(" " + _vm._s(_vm.$t("trf.new-trf")) + " "),
                  ]
                )
              : _vm._e(),
          ]),
          _vm.loadingList
            ? _c("div", { staticClass: "eu-pa_6 eu-align_center" }, [_vm._m(0)])
            : _vm._e(),
          !_vm.loadingList
            ? _c(
                "div",
                { staticClass: "emd-table-responsive" },
                [
                  _c("table", { staticClass: "emd-table" }, [
                    _c("thead", [
                      _c("tr", [
                        _c("th", [_vm._v(_vm._s(_vm.$t("trf.name")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("trf.date")))]),
                        _c("th", [_vm._v(_vm._s(_vm.$t("trf.size")))]),
                        _vm.permissionIsEnabled("trf.report:export")
                          ? _c("th")
                          : _vm._e(),
                      ]),
                    ]),
                    _c(
                      "tbody",
                      _vm._l(_vm.trfs.items, function (trf, index) {
                        return _c("tr", { key: index }, [
                          _c(
                            "td",
                            { attrs: { "data-label": _vm.$t("trf.name") } },
                            [_vm._v(_vm._s(trf.name))]
                          ),
                          _c(
                            "td",
                            { attrs: { "data-label": _vm.$t("trf.date") } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("dateFormat")(trf.date, "date")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _c(
                            "td",
                            { attrs: { "data-label": _vm.$t("trf.size") } },
                            [_vm._v(_vm._s(trf.size))]
                          ),
                          _vm.permissionIsEnabled("trf.report:export")
                            ? _c(
                                "td",
                                {
                                  staticClass: "eu-align_right",
                                  attrs: {
                                    "data-label": _vm.$t("trf.download"),
                                  },
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "emd-btn-ghost btn-download-trf",
                                      attrs: {
                                        href: _vm.$sanitize(trf.url),
                                        title: _vm.$t("trf.download"),
                                        rel: "noopener noreferrer",
                                      },
                                      on: { click: _vm.track },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "uil uil-arrow-to-bottom",
                                      }),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ])
                      }),
                      0
                    ),
                  ]),
                  !_vm.loadingList && _vm.trfs.pagination.total_items === 0
                    ? _c("empty-list", {
                        staticClass: "eu-pb_3",
                        attrs: { entity: "trf" },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _c(
        "Modal",
        { attrs: { open: _vm.modalOpenned } },
        [
          _c("template", { slot: "content" }, [
            _c(
              "div",
              {
                staticClass:
                  "emd-container _highlight_header _footer_end _footer_spaced_mobile",
              },
              [
                _c("div", { staticClass: "emd-container__header" }, [
                  _c("h2", { staticClass: "emd-text _size_section" }, [
                    _vm._v(" " + _vm._s(_vm.$t("trf.modal.title")) + " "),
                  ]),
                  !_vm.loadingTRF
                    ? _c(
                        "button",
                        {
                          staticClass: "emd-btn _type_link jsModalClose",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.closeModal()
                            },
                          },
                        },
                        [_c("i", { staticClass: "uil uil-times" })]
                      )
                    : _vm._e(),
                ]),
                _c(
                  "form",
                  {
                    attrs: { name: "formTRF", novalidate: "true" },
                    on: { submit: _vm.generateCustomTRF },
                  },
                  [
                    _vm.loadingTRF
                      ? _c(
                          "div",
                          { staticClass: "emd-container__content" },
                          [
                            _vm.loadingTRF
                              ? _c(
                                  "emd-alert",
                                  {
                                    attrs: {
                                      variant: "warning",
                                      title: _vm.$t(
                                        "trf.modal.alert-loading-title"
                                      ),
                                    },
                                    on: {
                                      cancel: function ($event) {
                                        _vm.loadingTRF = false
                                      },
                                    },
                                  },
                                  [
                                    _c("template", { slot: "content" }, [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("trf.modal.alert-loading")
                                          ) +
                                          " "
                                      ),
                                    ]),
                                  ],
                                  2
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "emd-loader _invert eu-align_center eu-pa_3",
                              },
                              [_c("div"), _c("div"), _c("div")]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "div",
                      { staticClass: "emd-container__content" },
                      [
                        _vm.showAlert
                          ? _c(
                              "emd-alert",
                              {
                                attrs: {
                                  variant: _vm.variantAlert,
                                  title: _vm.formError
                                    ? _vm.$t(
                                        "account.settings.alert.error-title"
                                      )
                                    : _vm.$t(
                                        "account.settings.alert.success-title"
                                      ),
                                },
                                on: {
                                  cancel: function ($event) {
                                    _vm.showAlert = false
                                  },
                                },
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _vm.formError
                                    ? _c(
                                        "div",
                                        _vm._l(
                                          _vm.errors,
                                          function (error, index) {
                                            return _c("p", { key: index }, [
                                              _vm._v(" " + _vm._s(error) + " "),
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _c("p", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "account.settings.saved-success"
                                            )
                                          )
                                        ),
                                      ]),
                                ]),
                              ],
                              2
                            )
                          : _vm._e(),
                        !_vm.loadingTRF && _vm.trfType === "custom"
                          ? _c("div", { staticClass: "el-section" }, [
                              _c(
                                "div",
                                { staticClass: "eu-flex eu-column eu-row_sm" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "eu-flex-item eu-basis_6_sm",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "emd-form-group",
                                          class: {
                                            _state_error:
                                              _vm.interval.startDate.error,
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "emd-label _required",
                                              attrs: { for: "startDate" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("trf.modal.start-date")
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("input-date", {
                                            attrs: {
                                              id: "startDate",
                                              value:
                                                _vm.interval.startDate.value,
                                              locale: _vm.locale,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.setDate(
                                                  $event,
                                                  "startDate"
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "eu-flex-item eu-basis_6_sm",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "emd-form-group",
                                          class: {
                                            _state_error:
                                              _vm.interval.endDate.error,
                                          },
                                        },
                                        [
                                          _c(
                                            "label",
                                            {
                                              staticClass:
                                                "emd-label _required",
                                              attrs: { for: "endDate" },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t("trf.modal.end-date")
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("input-date", {
                                            attrs: {
                                              id: "endDate",
                                              value: _vm.interval.endDate.value,
                                              locale: _vm.locale,
                                            },
                                            on: {
                                              input: function ($event) {
                                                return _vm.setDate(
                                                  $event,
                                                  "endDate"
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    !_vm.loadingTRF && _vm.trfType === "custom"
                      ? _c("div", { staticClass: "emd-container__footer" }, [
                          _c(
                            "button",
                            {
                              staticClass: "emd-btn _color_primary _type_text",
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  return _vm.closeModal()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("trf.modal.cancel")) + " "
                              ),
                            ]
                          ),
                          _c(
                            "button",
                            {
                              staticClass: "emd-btn _color_primary",
                              attrs: { type: "submit", id: "btn-generate-trf" },
                              on: { click: _vm.track },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("trf.modal.generate")) + " "
                              ),
                            ]
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
              ]
            ),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "emd-loader _invert" }, [
      _c("div"),
      _c("div"),
      _c("div"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }